<template>
  <div class="lg:w-1/6 md:w-1/4 sm:w-1/3 bg-white rounded">
  <!-- <v-select v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
  <v-select v-model="selected" :options="options"/>
</div>
</template>

<script>
import vSelect from 'vue-select'

export default{
  data() {
    return {
      options: [
      ],
      selected: {id: 1, label: '모든클래스'},
    }
  },
  watch: {
    selected(value) {
      var projectList = []
      for (var index in this.$store.state.project.workspaceProjects) {
        if(this.$store.state.project.workspaceProjects[index].workspace_id == value.id) {
          projectList.push({id:this.$store.state.project.workspaceProjects[index].id, label:this.$store.state.project.workspaceProjects[index].title})
        }
      }
      this.$store.commit('project/SET_SELECT_WORKSPACE', value)
      this.$store.commit('project/SET_PROJECT_LIST', projectList)
    },
  },
  components: {
    'v-select': vSelect,
  },
  created(){
    this.initData()
  },
  methods: {
    initData() {

    }
  }
}
</script>
